import { axiosHttpClient } from "../axios";
import handleStatusCases from "../handle-status-cases";

const { REACT_APP_BASE_URL } = process.env;

type TReadBudgetDocumentById = {
    budgetId: string;
};

export type TReadDocumentsDataResponse = {
    document: {
        id_e: string;
        document_title: string;
        enterprise: string;
        project: string;
        created_at: Date;
    };
    session: {
        id_e: string;
        session_title: string;
        type: string;
        content: string;
        position: number;
    }[];
}[];

export type TReadDocumentByIdResponse = TReadDocumentsDataResponse;

export default async ({ budgetId }: TReadBudgetDocumentById) => {
    const httpResponse = await axiosHttpClient({
        url: `${REACT_APP_BASE_URL}/budget/documents/${budgetId}`,
        method: "get",
        headers: { auth: true },
    });
    const { body, statusCode } = httpResponse;

    return handleStatusCases<TReadDocumentByIdResponse>({
        body,
        statusCode,
    });
};
